import type { InjectionKey, Ref } from 'vue';

/**
 * true hides the question and the answer area (Speed Round): a paused,
 * time-limited try must not be readable while a dialog stops its clock.
 * Provided by useStepDialogs; StepCard falls back to false.
 */
export const STEP_QUESTION_CONCEALED: InjectionKey<Readonly<Ref<boolean>>> =
  Symbol('stepQuestionConcealed');
